import request from '@/utils/request';


// Role
export function symbolsList(params) {
  return request({ url: `/symbols/getList`, method: 'get', params })
}

export function symbolsCreate(data) {
  return request({ url: `/symbols/add`, method: 'post', data })
}

export function symbolsUpdate(data) {
  return request({ url: `/symbols/update`, method: 'post', data })
}

export function symbolsDestroy(data) {
  return request({ url: `/symbols/delete`, method: 'post', data })
}

export function yzqmxsymbolsList(params) {
  return request({ url: `/yzqmxsymbols/getList`, method: 'get', params })
}

export function yzqmxsymbolsCreate(data) {
  return request({ url: `/yzqmxsymbols/add`, method: 'post', data })
}

export function yzqmxsymbolsUpdate(data) {
  return request({ url: `/yzqmxsymbols/update`, method: 'post', data })
}

export function yzqmxsymbolsDestroy(data) {
  return request({ url: `/yzqmxsymbols/delete`, method: 'post', data })
}


export function smsymbolsList(params) {
  return request({ url: `/smsymbols/getList`, method: 'get', params })
}

export function smsymbolsCreate(data) {
  return request({ url: `/smsymbols/add`, method: 'post', data })
}

export function smsymbolsUpdate(data) {
  return request({ url: `/smsymbols/update`, method: 'post', data })
}

export function smsymbolsDestroy(data) {
  return request({ url: `/smsymbols/delete`, method: 'post', data })
}

